import {
  DatePickerInput as MDatePickerInput,
  type DatePickerInputProps,
  type DatesRangeValue,
} from "@mantine/dates";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { toMantineDateString } from "src/utils/mantineDates";
import {
  type FieldValues,
  type Path,
  type PathValue,
  type UseFormSetValue,
} from "react-hook-form";

interface Props<T extends FieldValues> extends DatePickerInputProps {
  names: [Path<T>, Path<T>];
  setValue: UseFormSetValue<T>;
  returnFormat: string;
  values?: [string | undefined, string | undefined];
}

function DateRangeInput<T extends FieldValues>({
  names,
  setValue,
  returnFormat,
  values,
  ...props
}: Props<T>) {
  const [dates, setDates] = useState<DatesRangeValue>(
    values
      ? [toMantineDateString(values[0]), toMantineDateString(values[1])]
      : [null, null],
  );

  useEffect(() => {
    setDates([
      toMantineDateString(values?.[0]),
      toMantineDateString(values?.[1]),
    ]);
  }, [values?.[0], values?.[1]]);

  const handleChange = (newDates: DatesRangeValue) => {
    setDates(newDates);
    setValue(
      names[0],
      (newDates[0]
        ? dayjs(newDates[0]).format(returnFormat)
        : undefined) as PathValue<T, Path<T>>,
      { shouldValidate: true },
    );
    setValue(
      names[1],
      (newDates[1]
        ? dayjs(newDates[1]).format(returnFormat)
        : undefined) as PathValue<T, Path<T>>,
      { shouldValidate: true },
    );
  };

  return (
    <MDatePickerInput
      valueFormat="D MMM YYYY"
      type="range"
      value={dates}
      onChange={handleChange}
      dropdownType="modal"
      {...props}
    />
  );
}

export default DateRangeInput;
